import { motion } from "framer-motion";
import React from "react";

export function Motion({ children, scale, stiffness, damping, dontHover, style = {} }) {
    return (
        <motion.div
            whileHover={{ scale: scale ?? (dontHover ? 1 : 1.08) }}
            transition={{
                type: "spring",
                stiffness: stiffness ?? 150,
                damping: damping ?? 10,
            }}
            style={{ ...style }}
        >
            {children}
        </motion.div>
    );
}
